<template>
  <div class="yunwei" id="yunwei">
    <v-app>
      <v-app-bar app color='primary' dark height="564" absolute>
        <v-row align="start">
          <!-- 一级导航栏 -->
          <FirstNavbar :pc='pc' :tab_index="first_active_tab" :barHide="barHide" :barColor="barColor"></FirstNavbar>
          <div class='first_title_box'  style="width:100%;height:calc(564px - 64px);" >
            <v-row align="center" justify="center">
              <v-col cols="12">
                <h1 class="first_title white--text">
                  运维服务
                </h1>
                <h4 class="body_text white--text">
                  <span>诚信</span><span>规范</span><span>创新</span><span>高效</span>
                </h4>
              </v-col>
            </v-row>
          </div>
          <!-- 首屏大图 -->
          <div style="width:100%;height:500px;position:absolute;z-index:-3;margin-left:-4px">
            <v-parallax height="564" dark src="../assets/images/bg_about.png">
            </v-parallax>
          </div>
        </v-row>
      </v-app-bar>
      <v-main>
        <div class="aboutContent">
          <v-row dense>
            <v-col cols="12">
              <div class="contentBox">
                <div class="textBox">
                  <BoxTitle firstTitle="数据中心运维" desc="面向客户人性化管理设置，7 x 24 小时呼叫服务中心，在任何时候，都有专业的工程师（系统工程师， 网络工程师）随时待命" :index="1"></BoxTitle>
                  <v-expansion-panels focusable v-model='panel'>
                    <v-expansion-panel v-for="item in contentList" :key="item.index">
                      <v-expansion-panel-header>{{ item.title }}</v-expansion-panel-header>
                      <v-expansion-panel-content>
                        <v-row>
                          <div style="width:auto;padding:20px;min-width:250px" v-for="i in item.text.length" :key="i">
                            <v-list dense color="rgba(1,1,1,0)">
                              <v-list-item v-for="a in item.text[i-1].length" :key="a">
                                <v-list-item-content>
                                  <v-list-item-title>
                                    <p v-html="item.text[i-1][a-1]" class="body_text" style="line-height:1.5"></p>
                                  </v-list-item-title>
                                </v-list-item-content>
                              </v-list-item>
                            </v-list>
                          </div>
                        </v-row>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>
                </div>
              </div>
              <!-- 悬浮图标-回到顶部 -->
              <v-fab-transition>
                <v-btn
                  v-show="!floatHidden"
                  color="primary"
                  fixed
                  bottom
                  right
                  fab
                  @click="goTo(0)"
                >
                  <v-icon>mdi-arrow-up</v-icon>
                </v-btn>
              </v-fab-transition>
            </v-col>
          </v-row>
        </div>
      </v-main>
    <v-footer  color="secondary" style="height:auto">
      <FootContent :active="footList.active" :listWidth="footList.listWidth"></FootContent>
    </v-footer>
    </v-app>
  </div>
</template>

<script>
import FootContent from '../components/footer.vue'
import FirstNavbar from '../components/first-navbar.vue'
import BoxTitle from '../components/box-title.vue'

export default {
  name: 'yunwei',
  components: {
    FootContent,
    FirstNavbar,
    BoxTitle
  },
  data: () => ({
    // 导航背景颜色
    barColor: 'rgba(63, 81, 181,0)',
    // 导航栏是否隐藏
    barHide: true,
    // 是否为PC端
    pc: false,
    // 悬浮按钮是否隐藏
    floatHidden: true,
    // 一级导航选项卡
    first_active_tab: 1,
    // 页脚参数
    footList: {
      listWidth: '10rem',
      active: [true, true, true]
    },
    // 列表激活项
    panel: 0,
    contentList: [{
      index: 0,
      title: '基础运维',
      text: [['<strong>日常维护</strong>', '● 7x24小时值班&emsp;&emsp;', '● 现场巡检&emsp;&emsp;', '● 预防性维护&emsp;&emsp;'],
        ['<strong>设施监控</strong>', '● 动力、环境监控&emsp;&emsp;', '● 消防、安防监控&emsp;&emsp;', '● 楼宇自动化控制&emsp;&emsp;'],
        ['<strong>应急响应</strong>', '● 故障处理与应急响应', '● 应急预案及演练', '● 事件通报'],
        ['<strong>事件管理</strong>', '● 变更管理', '● 事件管理', '● 配置管理', '● 容量管理'],
        ['<strong>运维分析与报表</strong>', '● 运维报表', '● 能耗分析与趋势预测', '● 容量分析'],
        ['<strong>安全管理</strong>', '● 出入口管理', '● 安全管理']
      ]
    }, {
      index: 1,
      title: '增值服务',
      text: [['<strong>业务开通与移除</strong>', '● 设备上架', '● 设备下架', '● 设备上电', '● 设备下电', '● 设备替换、迁移', '● 设备测试'],
        ['<strong>综合布线</strong>', '● 线缆布放', '● 端口制作', '● 线缆、链路测试'],
        ['<strong>资产管理</strong>', '● 设备巡检', '● 设备代收发', '● 设备代管', '● 设备标识', '● 资产报表', '● 备品备件管理'],
        ['<strong>系统、网络监控</strong>', '● 系统、软件实时监控', '● 网络实时监控', '● 安全防御', '● 漏洞扫描'],
        ['<strong>办公配套</strong>', '● 独立办公室', '● 办公耗材', '● 独立库房'],
        ['<strong>客户授权操作</strong>', '● 线缆插拔', '● 介质更换', '● 设备开关机', '● 服务器硬件及系统维护', '● 网络、安全设备硬件及配置操作', '● 重点保障服务']
      ]
    }]
  }),
  mounted () {
    this.goTo(0)
    var that = this
    that.whatScreen()
    // 屏幕尺寸监听
    window.onresize = function () {
      that.whatScreen()
    }
  },
  methods: {
    // 屏幕
    whatScreen () {
      var width = document.querySelector('html').offsetWidth
      if (width <= 768) {
        // title.innerHTML = "极小屏幕-" + width
        this.footList.active = [false, false, false]
        this.footList.listWidth = '90rem'
        this.pc = false
      } else {
        if (width > 768 && width <= 992) {
          // title.innerHTML = "小屏幕-" + width
          this.footList.active = [true, true, true]
          this.footList.listWidth = '10rem'
          this.pc = false
        } else {
          if (width > 992 && width <= 1100) {
            // title.innerHTML = "普通屏幕-" + width
            this.footList.active = [true, true, true]
            this.footList.listWidth = '10rem'
            this.pc = true
          } else {
            if (width > 1200 && width <= 1600) {
              // title.innerHTML = "大屏幕-" + width
              this.footList.active = [true, true, true]
              this.footList.listWidth = '10rem'
              this.pc = true
            } else {
              if (width > 1600) {
                // title.innerHTML = "大屏幕-" + width
                this.footList.listWidth = '10rem'
                this.footList.active = [true, true, true]
                this.pc = true
              }
            }
          }
        }
      }
    },
    // 一级导航跳转定位
    toguid (path_, id) {
      const path = path_
      const Id = id
      localStorage.setItem('toId', Id)
      this.$router.push(path)
    },
    goTo (ele) {
      document.body.scrollTop = ele
      document.documentElement.scrollTop = ele
    }
  }

}
</script>

<style scoped>
#box.v-application .align-center {
    align-items: flex-start !important;
}
#box .v-application .justify-space-around {
    justify-content: flex-start !important;
}
</style>
